import React from 'react';
import PropTypes from 'prop-types';
import AlertPanel from 'components/AlertPanel';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { Caption } from 'components/Typography';

const DenyReasonPanel = (props) => {
    const { denyReason, classes } = props;
    const showPanel = Boolean(denyReason) && Boolean(denyReason.reasonDescription);
    const showCaption = showPanel && Boolean(denyReason.reasonCaption);
    return (
        <React.Fragment>
            {showPanel &&
                <AlertPanel
                    message={denyReason.reasonDescription}
                    variant="error"
                    className={classes.alertPanel}
                />
            }{showCaption &&
                <div className={classes.captionPanel} ><Caption className={classes.caption}> {denyReason.reasonCaption} </Caption> </div>
            }
        </React.Fragment>
    );
};

DenyReasonPanel.propTypes = {
    denyReason: PropTypes.shape({
        reasonDescription: PropTypes.string
    })
};

export default withStyles(styles)(DenyReasonPanel);